import { all } from "redux-saga/effects";
import { chuongTrinhDaoTaoSaga } from "./chuongTrinhDaoTaoSaga";
import { chuongTrinhDaoTaoChiTietSaga } from "./chuongTrinhDaoTaoChiTietSaga";
import { chuongTrinhDaoTaoKienThucSaga } from "./chuongTrinhDaoTaoKienThucSaga";
import { chuanDauRaChungChiSaga } from "./chuanDauRaChungChiSaga";
import { loaiChungChiDanhSachMonSaga } from "./loaiChungChiDanhSachMonSaga";

export default function* chuongTrinhDaoTaoSagaWrapper() {
  yield all([
    chuongTrinhDaoTaoSaga(),
    chuongTrinhDaoTaoChiTietSaga(),
    chuongTrinhDaoTaoKienThucSaga(),
    chuanDauRaChungChiSaga(),
    loaiChungChiDanhSachMonSaga(),
  ]);
}
